import React from 'react'
import './orderpage.css';
import { ProductsInfomation } from '../Constants/ProductsInfomation';
import { Footer } from '../../common/Footer';
import { useState } from 'react';
import { history } from '../../../';

export default function OrderPage() {
    const [instanceType, setInstanceType] = useState("dedicated");
    const [camEnvironment, setCAMEnvironment] = useState("");
    // const [stateVersion, setStateversion]= useState("")

    const handleChangeInstanceType = (event) => {
        const data = event.target.value.split(';')
        const idkey = event.target.id + 'version'
        setInstanceType(data[0]);
        // setStateversion(data[1])
        if (event.target.value === "container") {
            setCAMEnvironment("Production");
        }
        document.getElementById(idkey).innerText = "Version: "+data[1];
    };

    const handleClickCreate = (routeName) =>{
        history.push({
            pathname: `/fui/order/${routeName}`,
            state: { InstanceType: `${instanceType}`, CAMPortalEnvironment: `${process.env.REACT_APP_CAMENVPORTAL}` }
        });
    }
    return (
        <>
            <div className="order-title-page">
                Agent Mesh Provisioning
            </div>
            <div className="order-container">
                {ProductsInfomation.products.map((product) =>
                    product.type === "NETWORKS" &&
                    <>
                        <div className="order-product-tile">
                            <div className="product-name"></div>
                            {/* <hr style={{ width: '95%', border: '1px solid #EBEBEB' }} /> */}
                            <div className="product-picture">
                               {product.productName}
                            </div>
                            <div className="product-version" id={product.productName+'version'}>
                                <span> Version: {product.versions.dedicated} </span>  
                            </div>
                            <div className="product-description">
                                <p>
                                    {product.productDescription}
                                </p>
                            </div>
                            <div className='product-action'>
                                <div style={{ width: '50%' }}>
                                    <select onChange={(e)=>handleChangeInstanceType(e)} id={product.productName}>
                                        <option value={'dedicated;'+product.versions.dedicated}>Saas Dedicated</option>
                                        <option value={'container;'+product.versions.container}>SaaS</option>
                                    </select>
                                </div>
                                <div style={{ width: '50%' }}>
                                    <button onClick={()=>handleClickCreate(product.routeName)}>Create</button>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
            <Footer />
        </>
    )
}
